/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Mad_Lemming_NailInputs */

const fr_fresh_mad_lemming_nail = /** @type {(inputs: Fresh_Mad_Lemming_NailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de tours`)
};

/**

* @param {Fresh_Mad_Lemming_NailInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fresh_mad_lemming_nail = /** @type {((inputs?: Fresh_Mad_Lemming_NailInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Mad_Lemming_NailInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fresh_mad_lemming_nail(inputs)
});